import * as Yup from "yup";
import { reverseShape } from "Components/shared/helpers/reverse-shape";
import { time, date , dateRange,timeRange, validString, validBoolean } from "Components/shared/helpers/validations";



const parcelLists = Yup.array().min(1)


export const dropOffObj= Yup.object().shape(
  reverseShape({
    merchantID: validString.required(),
    noOfParcels: validString.required(),
    parcelList: parcelLists.required(),
    dropOffLocation: validString.required(),
    noOfDrivers: validString.required(),
    // dropOffTimeFrom: time.required(),
    // dropOffTimeTo: time.required().concat(timeRange),
    dropOffDate:validString.required(),
    dropOffTimeFrom: validString.required(),
    dropOffTimeTo: validString.required(),
    status: validString.required(),
  })
);

export const ParcelsDropOffCreateSchema = Yup.object().shape(
  reverseShape({
    dropoff: dropOffObj.required(),
    locationID: validString.required(),
    filtersFlag: validBoolean.required(),
  })
  );
